// Gmaps:
(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
	key: window.GOOGLE_MAPS_PUBLIC_KEY,
	v: "weekly",
	libraries: ["places","core","geometry","geocoding"],
});

// Vendor imports
import { Fancybox } from '@fancyapps/ui'

import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'
import breakpoint from 'alpinejs-breakpoints'
import resize from '@alpinejs/resize'
import persist from '@alpinejs/persist'


Alpine.plugin(persist)
Alpine.plugin(intersect)
Alpine.plugin(breakpoint)
Alpine.plugin(collapse)
Alpine.plugin(focus)
Alpine.plugin(resize)
window.Alpine = Alpine
window.AlpineBreakpointPluginBreakpointsList = [
	'xs',
	'sm',
	'md',
	'lg',
	'xl',
	'2xl',
	'3xl',
	'max',
	'wide',
]
window.Alpine.start()

import { gsap } from 'gsap'
window.gsap = gsap


import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import 'lazysizes'
import 'lazysizes/plugins/object-fit/ls.object-fit'

// Module imports
import './modules/carousel'
import './modules/collage'
import './modules/fancyapps'
import './modules/filters'
import './modules/masonry'
import './modules/richtext-new-window'
import './modules/set-scaling'
import './modules/set-themes'
import './modules/svgIconSprite'
import './modules/video-fit'
import './modules/global' // alpine global store
import './modules/donate'
import './modules/find-member'
import './modules/members'
import './modules/mouse-trace'
import './modules/scroller'

document.addEventListener('DOMContentLoaded', () => {
	setTimeout(() => {
		window.dispatchEvent(new Event('resize'));
	}, 100);

	document.querySelectorAll('[blur-on-click]').forEach(el => {
		el.addEventListener('click', ({ currentTarget }) => {
			currentTarget.blur();
		});
	});
});